import axios from "axios";

const _defaults = {
  url: `${process.env.VUE_APP_TYPEFORM_API_URL}/workspaces/${process.env.VUE_APP_TYPEFORM_WORKSPACE_ID}/forms`,
  client: axios
};

export const formService = (config = {}) => {
  const _client = config.client || _defaults.client;
  const _url = config.url || _defaults.url;
  const _filters = [];
  const _isPublicFilter = item => item.settings.is_public;

  return {
    get() {
      return _client
        .get(_url, {
          headers: {
            Authorization: `Bearer ${process.env.VUE_APP_TYPEFORM_API_KEY}`
          }
        })
        .then(
          res => {
            let items = res.data.items;

            _filters.forEach(filter => {
              items = res.data.items.filter(filter);
            });

            return { ...res.data, items };
          },
          err => console.log(err)
        );
    },

    wherePublic() {
      _filters.push(_isPublicFilter);
      return this;
    }
  };
};
